import DraggableGrid from "@components/draggable_grid/draggable_grid"
import store from "../store"
import('./grid.css')
export default function Grid(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this
    let grid = []
    let draggableGrid

    this.generate = () =>{
        elements.title_container = this.createElement('div','config-section-title mb-3','POSICIONAR GRÁFICOS')
        elements.grid_container = this.createElement('div', 'grid-lines-container')
        elements.grid_wrapper = this.createElement('div', 'grid-lines-wrapper')

        $(elements.grid_container).append(elements.grid_wrapper)

        $(container).append(elements.title_container, elements.grid_container)

        setTimeout(_=>{
            this.reloadGrid()
        },500)

    }

    this.reloadGrid = () =>{
        let charts = store.getCharts()
        let last_y = 0
        
        startGrid(charts)        

        $.each(grid, (i_line, line) =>{

            let start_index, end_index, current_name, el
            
            const start = (index, item) =>{
                start_index = index
                el = context.createElement('div', 'grid-item-wrapper grid-item-chart')
                current_name = item.name
                $(el).html(current_name)
            }

            const finish = (index,item) =>{
                end_index = index
                let size = (end_index - start_index) + 1
                $(el).css({
                    
                })

                draggableGrid.addItem({title: item.name, attributes: {y: last_y}})

                last_y += 100
            }

            line.forEach((item, i_col)=>{
                if(start_index == undefined){
                    start(i_col, item)
                } else {
                   if(item.name != current_name){
                       finish(i_col, item)
                    //    current = this.createElement('div')
                    //    $(elements.lines).append(current)
                   } 
                }
            })

            if(start_index != undefined && end_index == undefined){
                finish(line.length-1,{name:current_name})
            }
        })
    }

    this.update = () =>{

    }

    const startGrid = charts =>{

        const buildObj = chart =>{
            return {name:chart.chart_name}
        }

        $.each(charts, (name, chart) =>{
            grid.push([buildObj(chart),buildObj(chart),buildObj(chart),buildObj(chart)])
        })

        draggableGrid = new DraggableGrid({
            container: elements.grid_wrapper,
            gaps:{x:100, y:20, type:'px'},
            resize: {w: {icon:true, available:true}, h:{available:false}}
        })

        draggableGrid.generate()

    }
}

Grid.prototype = Object.create(BaseConstructor.prototype)